import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PharmaceuticalMarketAnalysisByAddressRequestModel } from '../models/licensed/pharmaceutical-market-analysis-by-address-request.model';
import { PharmaceuticalMarketAnalysisByCNPJRequestModel } from '../models/licensed/pharmaceutical-market-analysis-by-cnpj-request.model';
import { PharmaceuticalMarketAnalysisResponseModel } from '../models/licensed/pharmaceutical-market-analysis-response.model';
import { SearchScoreByCPFResponseModel } from '../models/licensed/responses/search-score-by-cpf-response.model';
import { EconomicGroupCNPJResponseModel } from '../models/licensed/economic-group-cnpj-response.model';
import { EconomicGroupResponseModel } from '../models/licensed/economic-group-response.model';
import { ViaCEPResponseModel } from '../models/licensed/via-cep-response.model';
import { EconomicGroupModel } from '../models/licensed/economic-group.model';
import { ApiService } from '../api/api.service';
import { UpdateEconomicGroupStoreRequestModel } from '../models/registers/request/updateEconomicGroupStore.model';
import { CnpjListResponseModel } from '../models/licensed/cnpj-list-response.model';

@Injectable({
  providedIn: 'root'
})
export class LicensedService {

  constructor(
    private api: ApiService
  ) { }

  getEconomicGroup(page: number): Observable<EconomicGroupModel> {
    return this.api.getEconomicGroup(page);
  }

  getCnpjListByEconomicGroupId(economicGroupId: number): Observable<CnpjListResponseModel>  {
    return this.api.getCnpjListByEconomicGroupId(economicGroupId);
  }

  updateStoreEconomicGroup(request: UpdateEconomicGroupStoreRequestModel): Observable<void> {
    return this.api.updateEconomicGroupStore(request);
  }

  performPharmaceuticalMarketAnalysis(request: PharmaceuticalMarketAnalysisByAddressRequestModel | PharmaceuticalMarketAnalysisByCNPJRequestModel): Observable<PharmaceuticalMarketAnalysisResponseModel> {
    return this.api.performPharmaceuticalMarketAnalysis(request)
  }

  getCEP(cep: string): Observable<ViaCEPResponseModel> {
    return this.api.getCEP(cep);
  }

  getAllEconomicGroup(): Observable<EconomicGroupResponseModel> {
    return this.api.getAllEconomicGroup();
  }

  getAllCNPJ(): Observable<EconomicGroupCNPJResponseModel> {
    return this.api.getAllCNPJ();
  } 

  getScore(cpf: string): Observable<SearchScoreByCPFResponseModel> {
    return this.api.getScore(cpf);
  }

  getEconomicGroupByName(name: string): Observable<EconomicGroupModel> {
    return this.api.getEconomicGroupByName(name);
  }

  createEconomicGroup(name: string): Observable<any> {
    return this.api.createEconomicGroup(name);
  }

  updateEconomicGroup(id: number, name: string, status: string): Observable<any> {
    return this.api.updateEconomicGroup(id, name, status);
  }

  bulkUpdateEconomicGroupStatus(ids: number[], status: string): Observable<any> {
    return this.api.bulkUpdateEconomicGroupStatus(ids, status);
  }
}

